const permissions = {
  subdivisionCatalog: 'MB013',
  subdivisionAdd: 'MB014',
  subdivisionEdit: 'MB015',
  subdivisionDelete: 'MB016'
};

export default permissions;
